// Convert country code to full name (reverse lookup)
export const getCountryName = (countryCode) => {
  const codeToName = {
    'GB': 'United Kingdom',
    'UK': 'United Kingdom',
    'US': 'United States',
    'USA': 'United States',
    'DE': 'Germany',
    'CA': 'Canada',
    'NG': 'Nigeria',
    'PK': 'Pakistan',
    'ES': 'Spain',
    'IN': 'India',
    'ID': 'Indonesia',
    'SG': 'Singapore',
    'ZW': 'Zimbabwe',
    'CM': 'Cameroon',
    'IE': 'Ireland',
    'LK': 'Sri Lanka',
    'FR': 'France',
    'IT': 'Italy',
    'AU': 'Australia',
    'BR': 'Brazil',
    'CD': 'Congo',
    'CO': 'Colombia',
    'MX': 'Mexico',
    'AR': 'Argentina',
    'NL': 'Netherlands',
    'BE': 'Belgium',
    'CH': 'Switzerland',
    'AT': 'Austria',
    'SE': 'Sweden',
    'NO': 'Norway',
    'DK': 'Denmark',
    'FI': 'Finland',
    'PL': 'Poland',
    'PT': 'Portugal',
    'GR': 'Greece',
    'TR': 'Turkey',
    'RU': 'Russia',
    'UA': 'Ukraine',
    'ZA': 'South Africa',
    'EG': 'Egypt',
    'KE': 'Kenya',
    'GH': 'Ghana',
    'MA': 'Morocco',
    'TN': 'Tunisia',
    'DZ': 'Algeria',
    'ET': 'Ethiopia',
    'UG': 'Uganda',
    'TZ': 'Tanzania',
    'CN': 'China',
    'JP': 'Japan',
    'KR': 'South Korea',
    'TH': 'Thailand',
    'MY': 'Malaysia',
    'PH': 'Philippines',
    'VN': 'Vietnam',
    'BD': 'Bangladesh',
    'NP': 'Nepal',
    'IL': 'Israel',
    'SA': 'Saudi Arabia',
    'AE': 'UAE',
    'QA': 'Qatar',
    'KW': 'Kuwait',
    'JO': 'Jordan',
    'LB': 'Lebanon',
    'CL': 'Chile',
    'PE': 'Peru',
    'EC': 'Ecuador',
    'VE': 'Venezuela',
    'UY': 'Uruguay',
    'PY': 'Paraguay',
    'BO': 'Bolivia',
    'CR': 'Costa Rica',
    'PA': 'Panama',
    'GT': 'Guatemala',
    'HN': 'Honduras',
    'SV': 'El Salvador',
    'NI': 'Nicaragua',
    'DO': 'Dominican Republic',
    'CU': 'Cuba',
    'JM': 'Jamaica',
    'HT': 'Haiti',
    'NZ': 'New Zealand',
    'CZ': 'Czech Republic',
    'HU': 'Hungary',
    'RO': 'Romania',
    'BG': 'Bulgaria',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'HR': 'Croatia',
    'RS': 'Serbia',
    'BA': 'Bosnia',
    'AL': 'Albania',
    'MK': 'North Macedonia',
    'ME': 'Montenegro',
    'XK': 'Kosovo',
    'EE': 'Estonia',
    'LV': 'Latvia',
    'LT': 'Lithuania',
    'BY': 'Belarus',
    'MD': 'Moldova',
    'GE': 'Georgia',
    'AM': 'Armenia',
    'AZ': 'Azerbaijan',
    'KZ': 'Kazakhstan',
    'UZ': 'Uzbekistan',
    'TM': 'Turkmenistan',
    'KG': 'Kyrgyzstan',
    'TJ': 'Tajikistan',
    'AF': 'Afghanistan',
    'IR': 'Iran',
    'IQ': 'Iraq',
    'SY': 'Syria',
    'YE': 'Yemen',
    'OM': 'Oman',
    'BH': 'Bahrain',
    'CY': 'Cyprus',
    'MT': 'Malta',
    'IS': 'Iceland',
    'LU': 'Luxembourg',
    'MC': 'Monaco',
    'LI': 'Liechtenstein',
    'AD': 'Andorra',
    'SM': 'San Marino',
    'VA': 'Vatican City',
    'MU': 'Mauritius',
    'SC': 'Seychelles',
    'MG': 'Madagascar',
    'MZ': 'Mozambique',
    'ZM': 'Zambia',
    'BW': 'Botswana',
    'NA': 'Namibia',
    'AO': 'Angola',
    'MM': 'Myanmar',
    'KH': 'Cambodia',
    'LA': 'Laos',
    'MN': 'Mongolia',
    'BT': 'Bhutan',
    'BN': 'Brunei',
    'TL': 'East Timor',
    'PG': 'Papua New Guinea',
    'FJ': 'Fiji'
  };

  if (!countryCode) return '';
  const code = countryCode.toUpperCase().trim();
  return codeToName[code] || code; // Return code itself if no mapping found
};

// Built once on first code lookup; countryMap is rebuilt per call, so deriving
// the code set every time would cost a table scan per rendered cell.
let knownCodes = null;

// Convert country name to code (original function)
export const countryList = (countryName) => {
  const countryMap = {
    'United Kingdom of Great Britain and Northern Ireland': 'GB',
    'United Kingdom': 'GB',
    'United States': 'US',
    'United States of America': 'US',
    'Germany': 'DE',
    'Canada': 'CA',
    'Nigeria': 'NG',
    'Pakistan': 'PK',
    'Spain': 'ES',
    'India': 'IN',
    'Indonesia': 'ID',
    'Singapore': 'SG',
    'Zimbabwe': 'ZW',
    'Cameroon': 'CM',
    'Ireland': 'IE',
    'Sri Lanka': 'LK',
    'France': 'FR',
    'Italy': 'IT',
    'Australia': 'AU',
    'Brazil': 'BR',
    'Congo (Democratic Republic of the)': 'CD',
    'Colombia': 'CO',
    'Mexico': 'MX',
    'Argentina': 'AR',
    'Netherlands': 'NL',
    'Belgium': 'BE',
    'Switzerland': 'CH',
    'Austria': 'AT',
    'Sweden': 'SE',
    'Norway': 'NO',
    'Denmark': 'DK',
    'Finland': 'FI',
    'Poland': 'PL',
    'Portugal': 'PT',
    'Greece': 'GR',
    'Turkey': 'TR',
    'Russia': 'RU',
    'Ukraine': 'UA',
    'South Africa': 'ZA',
    'Egypt': 'EG',
    'Kenya': 'KE',
    'Ghana': 'GH',
    'Morocco': 'MA',
    'Tunisia': 'TN',
    'Algeria': 'DZ',
    'Ethiopia': 'ET',
    'Uganda': 'UG',
    'Tanzania': 'TZ',
    'China': 'CN',
    'Japan': 'JP',
    'South Korea': 'KR',
    'Thailand': 'TH',
    'Malaysia': 'MY',
    'Philippines': 'PH',
    'Vietnam': 'VN',
    'Bangladesh': 'BD',
    'Nepal': 'NP',
    'Israel': 'IL',
    'Saudi Arabia': 'SA',
    'United Arab Emirates': 'AE',
    'Qatar': 'QA',
    'Kuwait': 'KW',
    'Jordan': 'JO',
    'Lebanon': 'LB',
    'Chile': 'CL',
    'Peru': 'PE',
    'Ecuador': 'EC',
    'Venezuela': 'VE',
    'Uruguay': 'UY',
    'Paraguay': 'PY',
    'Bolivia': 'BO',
    'Costa Rica': 'CR',
    'Panama': 'PA',
    'Guatemala': 'GT',
    'Honduras': 'HN',
    'El Salvador': 'SV',
    'Nicaragua': 'NI',
    'Dominican Republic': 'DO',
    'Cuba': 'CU',
    'Jamaica': 'JM',
    'Haiti': 'HT',
    'New Zealand': 'NZ',
    'Czech Republic': 'CZ',
    'Czechia': 'CZ',
    'Hungary': 'HU',
    'Romania': 'RO',
    'Bulgaria': 'BG',
    'Slovakia': 'SK',
    'Slovenia': 'SI',
    'Croatia': 'HR',
    'Serbia': 'RS',
    'Bosnia and Herzegovina': 'BA',
    'Albania': 'AL',
    'North Macedonia': 'MK',
    'Montenegro': 'ME',
    'Kosovo': 'XK',
    'Estonia': 'EE',
    'Latvia': 'LV',
    'Lithuania': 'LT',
    'Belarus': 'BY',
    'Moldova': 'MD',
    'Georgia': 'GE',
    'Armenia': 'AM',
    'Azerbaijan': 'AZ',
    'Kazakhstan': 'KZ',
    'Uzbekistan': 'UZ',
    'Turkmenistan': 'TM',
    'Kyrgyzstan': 'KG',
    'Tajikistan': 'TJ',
    'Afghanistan': 'AF',
    'Iran': 'IR',
    'Iraq': 'IQ',
    'Syria': 'SY',
    'Yemen': 'YE',
    'Oman': 'OM',
    'Bahrain': 'BH',
    'Cyprus': 'CY',
    'Malta': 'MT',
    'Iceland': 'IS',
    'Luxembourg': 'LU',
    'Monaco': 'MC',
    'Liechtenstein': 'LI',
    'Andorra': 'AD',
    'San Marino': 'SM',
    'Vatican City': 'VA',
    'Mauritius': 'MU',
    'Seychelles': 'SC',
    'Madagascar': 'MG',
    'Mozambique': 'MZ',
    'Zambia': 'ZM',
    'Botswana': 'BW',
    'Namibia': 'NA',
    'Angola': 'AO',
    'Myanmar': 'MM',
    'Burma': 'MM',
    'Cambodia': 'KH',
    'Laos': 'LA',
    'Mongolia': 'MN',
    'Bhutan': 'BT',
    'Brunei': 'BN',
    'East Timor': 'TL',
    'Timor-Leste': 'TL',
    'Papua New Guinea': 'PG',
    'Fiji': 'FJ',
    'Solomon Islands': 'SB',
    'Vanuatu': 'VU',
    'Samoa': 'WS',
    'Tonga': 'TO',
    'Kiribati': 'KI',
    'Tuvalu': 'TV',
    'Nauru': 'NR',
    'Palau': 'PW',
    'Marshall Islands': 'MH',
    'Micronesia': 'FM',
    // ISO long forms and names the geo backfill writes; without these the cell
    // renders raw text and no flag.
    'Russian Federation': 'RU',
    'Viet Nam': 'VN',
    'Syrian Arab Republic': 'SY',
    'Korea (South)': 'KR',
    'Burkina Faso': 'BF',
    'Ivory Coast': 'CI',
    "Côte d'Ivoire": 'CI',
    'Democratic Republic of the Congo': 'CD',
    'Togo': 'TG',
    'Benin': 'BJ',
    'Somalia': 'SO',
    'Sudan': 'SD',
    'Malawi': 'MW',
    // Names the SEMrush geo rows and addBrandV2's Intl.DisplayNames produce.
    'Korea (Republic of)': 'KR',
    'Korea, Republic of': 'KR',
    'Czechia (Czech Republic)': 'CZ',
    'Senegal': 'SN',
    'Taiwan': 'TW',
    'Taiwan, Province of China': 'TW',
    'Hong Kong': 'HK',
    'Hong Kong SAR China': 'HK',
    'UAE': 'AE',
    'Bosnia': 'BA',
    'Bosnia & Herzegovina': 'BA',
    'Venezuela (Bolivarian Republic of)': 'VE',
    'Türkiye': 'TR',
    'Turkiye': 'TR',
    'Belize': 'BZ',
    'Gabon': 'GA',
    'Congo - Kinshasa': 'CD',
    'Myanmar (Burma)': 'MM',
    'Maldives': 'MV',
    'Sierra Leone': 'SL',
    'Guinea': 'GN',
    'Mali': 'ML',
    'Liberia': 'LR',
    'South Sudan': 'SS',
    'Réunion': 'RE',
    'Reunion': 'RE',
    'Unknown': 'XX'
  };

  // The geo columns hold two dialects: full names ("United Kingdom: 431") and
  // bare ISO codes ("GB: 431"). A code missed this name-keyed lookup, fell to
  // 'XX', and formatTopGeos drops 'XX' — so a row with a known country rendered
  // as an empty cell. Pass a code through once it is one this map already knows.
  const name = String(countryName ?? '').trim();
  if (!name) return 'XX';
  if (countryMap[name]) return countryMap[name];

  const code = name.toUpperCase();
  if (code.length === 2) {
    if (!knownCodes) knownCodes = new Set(Object.values(countryMap));
    if (knownCodes.has(code)) return code;
  }

  return 'XX';
};

// ❌ REMOVE THIS LINE - it's causing the error:
// module.exports = countryList;